import React, { useState } from 'react';
import './EditUser.css';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../application/common/config';

export const EditUser: React.FC = () => {
  // get incoming data
  const dataString = localStorage.getItem('data');
  const data = dataString? JSON.parse(dataString) : null;

  const [Id, setId] = useState(data? data.Id : '');
  const [firstName, setFirstName] = useState(data ? data.FirstName : '')
  const [lastName, setlastName] = useState(data ? data.LastName: '')
  const [email, setEmail] = useState(data ? data.Email : '')

  // console.log("The Id received is: ", Id);

  // function for 'Submit' button
  const handleSubmit = async (event: { preventDefault: () => void; }) =>{
    event.preventDefault();  // prevent page refresh
    const editUser  = {         // the updated data I want to send
      FirstName: firstName,
      LastName: lastName,
      Email: email
    };
    // do post call to get PIC auth token
    const serviceAccount = {
      "accountName": `${config.ACCOUNT}`,
      "password": `${config.PASSWORD}`,
      "context": "All"
    };
    let bearerToken = "";
    try{
      // console.log(`${config.SERVICE_URL_API}`);
      const responseToken = await axios.post(`${config.SERVICE_URL_TASK}/auth/token`, serviceAccount);
      // console.log(responseToken.data);
      bearerToken = responseToken.data.serviceToken;
    }
    catch(error){
      console.log(error);
      bearerToken = "";
    }
    // set the header for the put call to send updated data to Kuali
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      'API-Key': 'Bearer ' + `${config.KUALI_BEARER}`,
    }; 
    try{
      // console.log(`${config.SERVICE_URL_API}`);
      const response = await axios.put(`${config.SERVICE_URL_TASK}/Kuali/EditUser/UserId/`+Id+'/FirstName/'+editUser.FirstName+'/LastName/'+editUser.LastName+'/Email/'+editUser.Email, editUser, {headers});
      // console.log('Data updated successfully', response.data);
      alert('Success!');

      // new Data
      const updateLocalStorage = {
        Id: data? data.Id : '',
        FirstName: editUser? editUser.FirstName : '',
        LastName: editUser? editUser.LastName : '',
        Email: editUser? editUser.Email : ''
      } 
      // update localStorage with new data
      localStorage.setItem('data', JSON.stringify(updateLocalStorage));
      window.location.reload();   // reload the page
    }
    catch(error){
       // Handle any error that occurred during the request
       console.error('Error updating data:', error);
       alert('Error!');
    }
  };
  // function for 'Clear Form' button
  const clearForm = ()=>{
    setFirstName('');
    setlastName('');
    setEmail('');
  }
  return (
    <div onSubmit = {handleSubmit} className="row">
        <form className="form-container">
            <div className="card">
                <div className="card-header">
                    <h3>Edit User</h3>
                </div>
                <div className="card-body">
                <div className="form-group">
                        <label>First Name</label>
                        <input 
                          className="form-control"
                          value = {firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                          >
                        </input>
                        <label>Last Name</label>
                        <input 
                          className="form-control"
                          value = {lastName}
                          onChange={(e) => setlastName(e.target.value)}
                          required
                          >
                        </input>
                        <label>Email</label>
                        <input 
                          className="form-control"
                          value = {email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          >
                        </input>
                    </div>
                </div>
                <div className="card-footer">
                    <Button
                      type = "submit" 
                      className="btnSave" 
                      >Save</Button> 
                    <Button 
                      className="btnClearForm"
                      onClick={clearForm}
                      >Clear Form</Button>
                </div>
            </div>
        </form>
    </div>
    );
};
export default EditUser;
